import { useSearchParams } from "react-router";

import { useWorkspaceSlug } from "@/components/helpers/custom-hooks/use-workspace-slug";
import { PageContainer } from "@/components/pages_flexible/PageContainer";

import { LearnArticle } from "./LearnArticle";

export function ArticleContainer() {
  const workspaceSlug = useWorkspaceSlug();
  const [searchParams] = useSearchParams();
  const isBareLayout = searchParams.get("layout") === "bare";

  return (
    <PageContainer
      workspace={workspaceSlug}
      maxWidth="100%"
      layout={isBareLayout ? "compact" : "full"}
    >
      <LearnArticle />
    </PageContainer>
  );
}
